(function () {
  'use strict';

  function updateDimensions(container, unit) {
    var items = container.querySelectorAll('.sg-dim-value');
    items.forEach(function (item) {
      var raw = item.getAttribute('data-val').toLowerCase().replaceAll(' ', '').replaceAll('inches', '').trim();
      if (raw.indexOf('x') === -1) return;

      var parts = raw.split('x');
      var vals = [];

      for (var i = 0; i < parts.length; i++) {
        var num = parseInt(parts[i]);
        if (isNaN(num)) { vals.push(parts[i]); continue; }

        if (unit === 'ft') {
          vals.push((num / 12).toFixed(2));
        } else if (unit === 'cm') {
          vals.push((2.54 * num).toFixed(2));
        } else {
          vals.push(num);
        }
      }

      var label = unit === 'ft' ? 'Ft' : unit === 'cm' ? 'CM' : 'Inches';
      item.textContent = vals.join(' x ') + ' ' + label;
    });
  }

  function init() {
    var modals = document.querySelectorAll('[class*="sg-modal"]');
    modals.forEach(function (modal) {
      var radios = modal.querySelectorAll('input[type="radio"][name^="sg-unit"]');
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          updateDimensions(modal, this.value);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.classList.contains('sg-modal') || node.querySelector('.sg-modal'))) {
          init();
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
